module.exports = __webpack_public_path__ + "static/saasy-no-software-50d98e6fe137788b3612644673a0c76a.png";